module.exports = __webpack_public_path__ + "img/0_bg.c17bbc06.png";